<template>
  <div class="ml-6 mr-6" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''">

    <v-alert v-if="alert" class="mb-3" border="top" :color="colorAlert" dark>
      {{ message }}
    </v-alert>

    <v-layout class="my-4" style="margin-left: 1px !important;" row wrap>
      <v-col class="d-flex ma-0 pa-0" cols="12" sm="2">
        <v-select
          :items="topicsentiment"
          item-text="TOPIC"
          item-value="SEQ_ID"
          v-model="selectedTopic"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Topic"
          dense
          outlined
          rounded
          @change="parameter_proses_topic()"
        ></v-select>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 ml-3" cols="12" sm="2">
        <v-select
          :items="periodeberita"
          v-model="selectedPeriode"
          class="elevation-0 shadow-0"
          color="var(--color-theme)"
          :item-color="themeItemColor"
          label="Periode"
          dense
          outlined
          rounded
          @change="parameter_proses_periode()"
        >
          <template v-slot:append-item>
            <v-list-item>
              <v-list-item-title>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-width="200"
                  offset-x
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      small
                      dark
                      width="120"
                      color="var(--color-theme)"
                    >
                      Custom
                    </v-btn>
                  </template>
                  <v-card>
                    <v-row class="pa-8" justify="space-around">
                      <v-date-picker
                        v-model="dateStart"
                        :show-current="false"
                        class="custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                      <v-date-picker
                        v-model="dateEnd"
                        :show-current="false"
                        class="ml-8 custom-date-picker"
                        color="var(--color-theme)"
                        @change="showPeriodeDate"
                      ></v-date-picker>
                    </v-row>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="#000" text @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="var(--color-theme)"
                        text
                        @click="parameter_proses_custom()"
                      >
                        Set
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-list-item-title>
            </v-list-item>
          </template>
        </v-select>
      </v-col>
      <v-col
        v-if="showDateStart != '' && showDateEnd != ''"
        class="d-flex ma-0 pa-0 ml-3"
        cols="12"
        sm="3"
      >
        <v-card style="border-radius: 30px; width: 100%;" height="40" outlined>
          <v-card-text class="pa-2 px-4">
            <v-icon>mdi-calendar</v-icon>
            <span class="mt-2 ml-1">
              {{ showDateStart[1] + " " + showDateStart[0] + " " + showDateStart[2] }} - {{ showDateEnd[1] + " " + showDateEnd[0] + " " + showDateEnd[2] }}
            </span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="d-flex ma-0 pa-0 ml-3" sm="1">
        <v-btn
          color="var(--color-theme-secondary)"
          style="max-width: 100%;"
          height="40"
          dense
          dark
          rounded
          block
          @click="isSearch = true, parameter_proses_topic(), loadMostLeastCrawler(), loadKontenBerita()"
        >
          <v-icon>mdi-magnify</v-icon>
          Search
        </v-btn>
      </v-col>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg4>
        <v-card class="mx-3 elevation-0" style="border-radius: 8px; color: #0471A5;" color="#fff" height="128" x-large>
          <v-card-text>
            <h2 class="primary--text darken-2 my-2" align="center" justify="center">
              {{ totalCollectedData }}
            </h2>
            <h4 class="text--teal darken-2 my-2" align="center" justify="center">
              Total Collected Data
            </h4>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg4>
        <v-card
          :class="{
            'mx-3 elevation-0 pa-7': !valueMostTotalKeyword.name,
            'mx-3 elevation-0 x-large': valueMostTotalKeyword.name
          }"
          style="border-radius: 8px; color: #0471A5;"
          color="#fff"
        >
          <v-card-text>
            <div class="text-center">
              <h2 class="primary--text darken-2 my-2">
                {{ valueMostTotalKeyword.count }}
              </h2>
              <h4 class="text--teal darken-2 my-2">
                Most Collected Keyword
              </h4>
              <h4 class="text--teal darken-2 my-2">
                {{ valueMostTotalKeyword.name }}
              </h4>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg4>
        <v-card
          :class="{
            'mx-3 elevation-0 pa-7': !valueLeastTotalKeyword.name,
            'mx-3 elevation-0 x-large': valueLeastTotalKeyword.name
          }"
          style="border-radius: 8px; color: #0471A5;"
          color="#fff"
        >
          <v-card-text>
            <div class="text-center">
              <h2 class="primary--text darken-2 my-2">
                {{ valueLeastTotalKeyword.count }}
              </h2>
              <h4 class="text--teal darken-2 my-2">
                Least Collected Keyword
              </h4>
              <h4 class="text--teal darken-2 my-2">
                {{ valueLeastTotalKeyword.name }}
              </h4>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex lg12>
        <v-card class="mx-3 my-5 elevation-0" height="auto" flat>
          <v-card-title class="mt-1 ml-1">Periodic Crawled Data</v-card-title>
          <v-row class="ml-5">
            <v-flex xs12 sm12 md12 lg2>
              <div class="d-flex pb-4" style="width: 800px; overflow: initial; text-overflow: initial; overflow-x: scroll;">
                <v-card class="mr-8 mt-6" style="width: 100%;" flat>
                  <v-checkbox
                    v-model="isAllKeyword"
                    label="All Keywords"
                  ></v-checkbox>
                </v-card>
              </div>
            </v-flex>
            <v-flex xs12 sm12 md12 lg10>
              <div class="d-flex flex-column mx-3 mt-3">
                <v-row class="d-flex pb-4" style="overflow-x: scroll;">
                  <v-col v-for="(item, index) in valueTotalKeyword" :key="index" cols="12" sm="6" md="4" lg="3">
                    <v-card class="card-shadow mx-3 elevation-0 mt-3" outlined x-large>
                      <v-card-text>
                        <h2 class="primary--text darken-2 my-2" align="center">
                          {{ item.value }}
                        </h2>
                        <h4 class="text--teal darken-2 my-2" align="center">
                          {{ item.keyword }}
                        </h4>
                      </v-card-text>
                    </v-card>
                  </v-col>
                  <v-col cols="12" sm="6" md="4" lg="3">
                    <v-card class="card-shadow mx-3 my-3" style="cursor: pointer" color="#fff" outlined x-large @click="addKeyword = true">
                      <v-card-text>
                        <h2 class="primary--text darken-2 my-2" align="center">
                          <v-icon>mdi-plus</v-icon>
                        </h2>
                        <h4 class="text--teal darken-2 my-2" align="center">
                          Add Specific Keyword
                        </h4>
                        <v-select
                          v-if="addKeyword"
                          :items="topickeywordsentiment"
                          v-model="selectedAddSpecificKeyword"
                          class="elevation-0 shadow-0"
                          label="Keyword"
                          dense
                          outlined
                          rounded
                          multiple
                          @change="handleAddSpecificKeyword"
                        ></v-select>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </v-flex>
          </v-row>

          <v-row class="pa-0 ma-0 d-flex">
            <v-flex lg10>
              <div class="example ml-4 mb-4">
                <apexcharts
                  :options="sentimentanalysis"
                  :series="seriessentiment"
                  class="mr-3"
                  type="line"
                  width="100%"
                  height="300px"
                ></apexcharts>
              </div>
            </v-flex>

            <v-flex lg2 xs12 sm12 md12 class="mt-5">
              <v-flex v-for="(item, index) in listSourceCollection" :key="item.ID" xs12 sm12 md12 lg4>
                <v-btn
                  :style="{ backgroundColor : selectedSourceId == item.ID ? '#e1f2fa' : '#fff' }"
                  class="mx-3 my-3"
                  color="#fff"
                  x-large
                  width="180px"
                  height="80"
                  style="color: #0471A5; border-radius: 8px; box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;"
                  @click="
                    if (selectedSourceId === item.ID) {
                      selectedSourceId = '';
                      sourceCollection = '';
                      changeBackgroundColor = !changeBackgroundColor;
                    } else {
                      selectedSourceId = item.ID;
                      sourceCollection = item.NAME_COLLECTION;
                      changeBackgroundColor = true;
                    }
                    loadKontenBerita()
                  "
                >
                  <v-card-text>
                    <h2 class="text--teal darken-2" align="center" justify="center">
                      <v-avatar v-if="item.ICON == 'fa-thin fa-globe'" class="color-avatarberitaonline" size="36">
                        <v-icon class="white--text">
                          {{ item.ICON }}
                        </v-icon>
                      </v-avatar>
                      <v-avatar v-if="item.ICON == 'fa-brands fa-x-twitter'" class="color-avatarXTikTok" size="36">
                        <v-icon class="white--text">
                          {{ item.ICON }}
                        </v-icon>
                      </v-avatar>
                      <v-avatar v-if="item.ICON == 'fa-brands fa-youtube'" class="color-avatarYtb" size="36">
                        <v-icon class="white--text">
                          {{ item.ICON }}
                        </v-icon>
                      </v-avatar>
                      <v-avatar v-if="item.ICON == 'fa-brands fa-tiktok'" class="color-avatarXTikTok" size="36">
                        <v-icon class="white--text">
                          {{ item.ICON }}
                        </v-icon>
                      </v-avatar>
                      <v-avatar v-if="item.ICON == 'mdi-instagram'" class="color-avatarIG" size="36">
                        <v-icon class="white--text">
                          {{ item.ICON }}
                        </v-icon>
                      </v-avatar>
                      <span>
                        {{ totalsByNameChart[index].total }} ({{ totalCollectedData ? Math.round((totalsByNameChart[index].total / totalCollectedData) * 100) : 0 }}%)
                      </span>
                    </h2>
                    <h5 v-if="item.ICON == 'fa-thin fa-globe'" class="text--teal darken-2" align="center" justify="center">
                      Total Berita Online
                    </h5>
                    <h5 v-if="item.ICON == 'fa-brands fa-x-twitter'" class="text--teal darken-2" align="center" justify="center">
                      Total Tweet
                    </h5>
                    <h5 v-if="item.ICON == 'fa-brands fa-youtube'" class="text--teal darken-2" align="center" justify="center">
                      Total Comment Youtube
                    </h5>
                    <h5 v-if="item.ICON == 'fa-brands fa-tiktok'" class="text--teal darken-2" align="center" justify="center">
                      Total TikTok
                    </h5>
                    <h5 v-if="item.ICON == 'mdi-instagram'" class="text--teal darken-2" align="center" justify="center">
                      Total Instagram
                    </h5>
                  </v-card-text>
                </v-btn>
              </v-flex>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center">
          Loading content, please wait
        </v-card-text>
        <v-card-title class="align-center justify-center">
          <v-progress-circular
              color="var(--color-theme)"
              :size="70"
              :width="7"
              indeterminate
          ></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="var(--color-theme)" text @click="dialog = false">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <Notification ref="alert"></Notification>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import VueApexCharts from 'vue-apexcharts';
import HighCharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import Notification from "@/components/Notification";
import { decryptionData, generate_filterdate } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
highchartsMore(HighCharts);

export default {
  components: {
    apexcharts: VueApexCharts,
    Notification: Notification
  },
  data() {
    return {
      isSearch: false,
      changeBackgroundColor: false,
      listSourceCollection: "",
      selectedSourceId: "",
      sourceCollection: "",
      totalCollectedData: "",
      isAllKeyword: true,
      addKeyword: false,
      valueTotalKeyword: [],
      valueLeastTotalKeyword: {
        name: "",
        value: ""
      },
      valueMostTotalKeyword: {
        name: "",
        value: ""
      },
      valueTotalCollected: 0,
      dialog: false,
      menu: false,
      totalsByNameChart: [],
      valueTotalBerita: "",
      valueTotalTwet: "",
      valueTotalYtb: "",
      valueTotalTikTok: "",
      valueTotalIG: "",

      selectedTopic: "",
      selectedKeyword: "",
      selectedAddSpecificKeyword: [],
      previousSelectedAddSpecificKeyword: [],
      selectedPeriode: "This Week",
      topicsentiment: [],
      topickeywordsentiment: [],
      periodeberita: ['Today', 'From Yesterday', 'This Week', 'Previous Week', 'This Month', 'Previous Month'],
      isShowDate: false,
      showDateStart: "",
      showDateEnd: "",
      dateStart: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      dateEnd: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      statusFilter: "",
      rowsChartArea: "",
      pageplay: 100,

      sentimentanalysis: {
        chart: { id: 'Memory Usage', type: 'line' },
        legend: {
          showForSingleSeries: true
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: [
          "#6F6F6F", "#FFB000", "#814AD6", "#000", "#FF0000",
          "#bd0ca0", "#4b5320", "#3bacad", "#b2e069", "#b9a389"
        ],
        xaxis: {
          categories: []
        }
      },
      seriessentiment: [],
      alert: false,
      colorAlert: "",
      message: "",
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
    themeItemColor() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700' ? 'var(--color-theme)' : undefined;
    },
    isColorThemeSetneg() {
      const colorTheme = getComputedStyle(document.documentElement).getPropertyValue('--color-theme').trim();
      return colorTheme == '#895700';
    }
  },
  mounted() {
    this.loadTopic();
  },
  watch: {
    selectedAddSpecificKeyword(newVal, oldVal) {
      if (this.previousSelectedAddSpecificKeyword.length == 0) {
        oldVal = [];
      }
      this.previousSelectedAddSpecificKeyword = [...oldVal];
      if (newVal.length < oldVal.length) {
        const unselectedKeywords = oldVal.filter(
          (keyword) => !newVal.includes(keyword)
        );
        if (unselectedKeywords.includes("All") && oldVal[0] == "All") {
          this.selectedAddSpecificKeyword = [...oldVal];
        }
        if ((!unselectedKeywords.includes("All") || oldVal[0] != "All") && this.selectedAddSpecificKeyword.length != 1) {
          this.previousSelectedAddSpecificKeyword = this.previousSelectedAddSpecificKeyword.filter(
            (keyword) => !unselectedKeywords.includes(keyword)
          );
        }
      }
    },
  },
  methods: {
    async loadTopic() {
      this.dialog = true;
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem("token_app") } },
        { dataType: 'json' }
      )
      .then((response) => {
        const data_dec = decryptionData(response.data.token);
        this.posts = data_dec.keyword;
        const data = data_dec.keyword;

        for (let i = 0; i < data.length; i++) {
          if (i == 0) {
            if (this.$store.topic_glob == "" || this.$store.topic_glob == undefined) {
              this.selectedTopic = data[i].SEQ_ID;
            } else {
              this.selectedTopic = this.$store.topic_glob;
            }
          }
          this.topicsentiment.push(data[i]);
        }
        this.$store.commit("addTopicKeyword", {
          topickeywordsentiment_glob: data,
        });
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < data.length; i++) {
          if (data[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < data[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  this.selectedKeyword = all;
                  this.selectedAddSpecificKeyword = [ "All" ];
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                  this.selectedAddSpecificKeyword = [ "All" ];
                }
              }
              this.topickeywordsentiment.push(data[i].KEYWORD[x].KEYWORD);
            }
          }
        }

        this.isShowDate = this.$store.is_show_date_glob;
        var date_start = this.dateStart;
        var date_end = this.dateEnd;
        if (this.$store.jenis_parameter_glob == "custom") {
          date_start = this.$store.date_start_glob;
          date_end = this.$store.date_end_glob;
        } else {
          let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
          let date_v = generate_filterdate(period);
          date_start = date_v.start_date;
          date_end = date_v.end_date;
        }

        if (this.$store.date_start_glob == "" || this.$store.date_start_glob == undefined) {
          this.$store.commit("addParameter", {
            jenis_parameter_glob: "periode",
            topic_glob: this.selectedTopic,
            topic_glob2: this.selectedKeyword,
            selectedPeriode_glob: this.selectedPeriode,
            date_start_glob: date_start,
            date_end_glob: date_end,
            is_show_date_glob: this.isShowDate
          });
        } else {
          this.selectedKeyword = this.$store.topic_glob2;
          this.selectedPeriode = this.$store.selectedPeriode_glob;
          this.dateStart = this.$store.date_start_glob;
          this.dateEnd = this.$store.date_end_glob;
        }

        if (data.length > 0) {
          this.loadMostLeastCrawler();
          this.loadKontenBerita();
        }
        if (this.isShowDate == true) {
          this.showPeriodeDate();
        }

        this.listSourceCollection = data_dec.collection;
      })
      .catch((e) => {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select refused to connect";
          this.colorAlert = "red";
        }
      });
    },
    async parameter_proses_topic() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      if (this.isSearch == true) {
        this.valueTotalKeyword = [];
        this.selectedAddSpecificKeyword = [ "All" ];
        this.previousSelectedAddSpecificKeyword = [];
        this.topickeywordsentiment = [];
        let all = "All";
        for (let i = 0; i < this.$store.topickeywordsentiment_glob.length; i++) {
          if (this.$store.topickeywordsentiment_glob[i].SEQ_ID == this.selectedTopic) {
            this.topickeywordsentiment.push(all);
            for (let x = 0; x < this.$store.topickeywordsentiment_glob[i].KEYWORD.length; x++) {
              if (x == 0) {
                if (this.$store.topic_glob2 == "" || this.$store.topic_glob2 == undefined) {
                  this.selectedKeyword = all;
                } else {
                  this.selectedKeyword = this.$store.topic_glob2;
                  this.selectedAddSpecificKeyword = [ "All" ];
                }
              }
              this.topickeywordsentiment.push(this.$store.topickeywordsentiment_glob[i].KEYWORD[x].KEYWORD);
            }
          }
        }
      }
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },
    async parameter_proses_keyword() {
      var date_start = this.dateStart;
      var date_end = this.dateEnd;
      this.$store.commit("addParameter", {
        jenis_parameter_glob: this.$store.jenis_parameter_glob,
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
      this.loadKontenBerita();
    },
    async parameter_proses_periode() {
      let date_start = this.dateStart;
      let date_end = this.dateEnd;
      if (this.selectedPeriode != 'Custom') {
        let period = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
        let date_v = generate_filterdate(period);
        date_start = date_v.start_date;
        date_end = date_v.end_date;
        this.dateStart = date_start;
        this.dateEnd = date_end;
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "periode",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });

      this.showPeriodeDate();
    },
    async parameter_proses_custom() {
      this.selectedPeriode = "Custom";

      var date_start = this.dateStart;
      var date_end = this.dateEnd;

      this.$store.commit("addParameter", {
        jenis_parameter_glob: "custom",
        topic_glob2: this.selectedKeyword,
        topic_glob: this.selectedTopic,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: date_start,
        date_end_glob: date_end,
        is_show_date_glob: this.isShowDate
      });
    },

    async loadMostLeastCrawler() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const response = await axios.post(
          `most-least-crawler?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );

        const data = decryptionData(response.data.token);
        const cleanKeyword = (keyword) => keyword.replace(/content:|clean_text:|text:/g, "").replace(/~2/g, "");

        const mergeCrawlerData = (crawlerArray, combinedData) => {
          if (Array.isArray(crawlerArray) && crawlerArray.length) {
            crawlerArray.forEach((item) => {
              if (item.most) {
                Object.entries(item.most).forEach(([name, count]) => {
                  const cleanName = cleanKeyword(name);
                  combinedData[cleanName] = (combinedData[cleanName] || 0) + count;
                });
              }
            });
          }
        };

        const combinedData = {};

        mergeCrawlerData(data.most_crawler, combinedData);
        mergeCrawlerData(data.most_crawlerTwitter, combinedData);
        mergeCrawlerData(data.most_crawlerYoutube, combinedData);
        mergeCrawlerData(data.most_crawlerInstagram, combinedData);
        mergeCrawlerData(data.most_crawlerTikTok, combinedData);

        const combinedArray = Object.entries(combinedData).map(([name, count]) => ({ name, count }));

        const mostFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count > current.count ? prev : current)) : { name: "-", count: 0 };
        const leastFrequent = combinedArray.length ? combinedArray.reduce((prev, current) => (prev.count < current.count ? prev : current)) : { name: "-", count: 0 };

        this.valueMostTotalKeyword = mostFrequent;
        this.valueLeastTotalKeyword = leastFrequent;

        window.dispatchEvent(new Event("resize"));
        this.dialog = false;
      } catch (e) {
        console.error(e);
        this.dialog = false;
        this.alert = true;
        this.message = "API Most Least Crawler Response Data Not Found";
        this.colorAlert = "red";
        setTimeout(() => {
          this.alert = false;
        }, 10000);
      }
    },

    async loadKontenBerita() {
      this.alert = false;
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }
        const data_chart_pie = await axios.post(
          `dashboar-chart-sentiment?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&start=0&rows=${this.pageplay}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        this.valueTotalBerita = data_chart_pie.data.data.count_news;
        this.valueTotalTwet = data_chart_pie.data.data.count_twitter;
        this.valueTotalYtb = data_chart_pie.data.data.count_youtube;
        this.valueTotalTikTok = data_chart_pie.data.data.count_tiktok;
        this.valueTotalIG = data_chart_pie.data.data.count_instagram;

        this.totalCollectedData = this.valueTotalBerita + this.valueTotalTwet + this.valueTotalYtb + this.valueTotalTikTok + this.valueTotalIG;

        this.totalsByNameChart = this.listSourceCollection.map(item => {
          switch(item.NAME_COLLECTION) {
            case 'mediaonline':
              return { total: this.valueTotalBerita };
            case 'twitter':
              return { total: this.valueTotalTwet };
            case 'youtube':
              return { total: this.valueTotalYtb };
            case 'tiktok_com':
              return { total: this.valueTotalTikTok };
            case 'instagram2':
              return { total: this.valueTotalIG };
            default:
              return { total: 0 };
          }
        });

        this.loadChartArea();
      } catch(e) {
        this.dialog = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Sentiment Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },

    async loadChartArea() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        this.rowsChartArea = this.valueTotalBerita;

        const data_chart_area = await axios.post(
          `dashboard-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${this.$store.topic_glob2}&sentiment=${this.statusFilter}&start=0&rows=${this.rowsChartArea}`,
          {},
          {
            headers: {
              'auth-token': authToken,
            },
          }
        );
        this.processData(data_chart_area.data.data);
      } catch(e) {
        this.dialog = false;
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Area Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },

    processData(data) {
      const allDates = new Set();

      const platforms = [
        ...(data.date_mediaonline || []),
        ...(data.date_twitter || []),
        ...(data.date_tiktok || []),
        ...(data.date_youtube || [])
      ];

      const dateTotals = {};

      platforms.forEach(item => {
        const date = item.date;
        allDates.add(date);
        dateTotals[date] = (dateTotals[date] || 0) + item.Total;
      });

      const sortedDates = Array.from(allDates).sort();

      this.seriessentiment = [{
        name: "All",
        data: []
      }];

      sortedDates.forEach(date => {
        const formattedDate = this.formatDate(date);
        this.seriessentiment[0].data.push({
          x: formattedDate,
          y: dateTotals[date] || 0
        });
      });

      this.sentimentanalysis.xaxis.categories = sortedDates.map(date => new Date(date).getTime());

      this.dialog = false;
    },

    async handleAddSpecificKeyword() {
      this.dialog = true;
      try {
        const authToken = localStorage.getItem("token_app");
        if (!authToken) {
          throw new Error("Auth token not found");
        }

        this.rowsChartArea = this.valueTotalBerita;

        const currentSelection = this.selectedAddSpecificKeyword;
        const previousSelectedAddSpecificKeyword = this.previousSelectedAddSpecificKeyword || [];

        const addedKeywords = currentSelection.filter(x => !previousSelectedAddSpecificKeyword.includes(x));
        const removedKeywords = previousSelectedAddSpecificKeyword.filter(x => !currentSelection.includes(x));

        removedKeywords.forEach(keyword => {
          if (keyword != "All") {
            const seriesIndex = this.seriessentiment.findIndex(s => s.name == keyword);
            if (seriesIndex >= 0) {
              this.seriessentiment.splice(seriesIndex, 1);
            }

            const valueIndex = this.valueTotalKeyword.findIndex(item => item.keyword == keyword);
            if (valueIndex >= 0) {
              this.valueTotalKeyword.splice(valueIndex, 1);
            }
          } else {
            const allSeriesIndex = this.seriessentiment.findIndex(s => s.name == "All");
            if (allSeriesIndex >= 0) {
              this.seriessentiment.splice(allSeriesIndex, 1);
            }
            const allValueIndex = this.valueTotalKeyword.findIndex(item => item.keyword == "All");
            if (allValueIndex >= 0) {
              this.valueTotalKeyword.splice(allValueIndex, 1);
            }
          }
          this.dialog = false;
        });

        for (const keyword of addedKeywords) {
          if (keyword == "All") {
            const allData = await this.fetchChartData(authToken, "");
            this.processBaseData(allData);

            const total = [
              ...(allData.date_mediaonline || []),
              ...(allData.date_twitter || []),
              ...(allData.date_tiktok || []),
              ...(allData.date_youtube || [])
            ].reduce((sum, item) => sum + item.Total, 0);

            this.updateValueTotalKeyword("All", total);
          } else {
            const keywordData = await this.fetchChartData(authToken, keyword);
            this.processKeywordData(keywordData, keyword);

            const total = [
              ...(keywordData.date_mediaonline || []),
              ...(keywordData.date_twitter || []),
              ...(keywordData.date_tiktok || []),
              ...(keywordData.date_youtube || [])
            ].reduce((sum, item) => sum + item.Total, 0);

            this.updateValueTotalKeyword(keyword, total);
          }
        }

        this.previousSelectedAddSpecificKeyword = [...currentSelection];
      } catch(e) {
        this.dialog = false;
        if (e.response) {
          const { status } = e.response;
          switch (status) {
            case 404: this.$refs.alert.error_login(404); break;
            case 403: this.$refs.alert.error_login(403); break;
            default: console.log("some other error"); break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Dashboard Chart Area Response Data Not Found";
          this.colorAlert = "red";
        }
      }
    },

    updateValueTotalKeyword(keyword, total) {
      const existingIndex = this.valueTotalKeyword.findIndex(item => item.keyword == keyword);

      if (existingIndex >= 0) {
        this.valueTotalKeyword[existingIndex].value = total;
      } else {
        const selectedIndex = this.selectedAddSpecificKeyword.indexOf(keyword);
        if (selectedIndex >= 0) {
          this.valueTotalKeyword.splice(selectedIndex, 0, {
            value: total,
            keyword: keyword
          });
        } else {
          this.valueTotalKeyword.push({
            value: total,
            keyword: keyword
          });
        }
      }
    },

    async fetchChartData(authToken, keyword) {
      const response = await axios.post(
        `dashboard-chart-area?start_date=${this.$store.date_start_glob}&end_date=${this.$store.date_end_glob}&topic=${this.$store.topic_glob}&keyword=${keyword}&sentiment=${this.statusFilter}&start=0&rows=${this.rowsChartArea}`,
        {},
        { headers: { 'auth-token': authToken } }
      );
      return response.data.data;
    },

    processBaseData(data) {
      const allDates = new Set();
      const platforms = [
        ...(data.date_mediaonline || []),
        ...(data.date_twitter || []),
        ...(data.date_tiktok || []),
        ...(data.date_youtube || [])
      ];

      const dateTotals = {};
      platforms.forEach(item => {
        const date = item.date;
        allDates.add(date);
        dateTotals[date] = (dateTotals[date] || 0) + item.Total;
      });

      const sortedDates = Array.from(allDates).sort();

      const allSeriesIndex = this.seriessentiment.findIndex(s => s.name == "All");
      if (allSeriesIndex >= 0) {
        this.seriessentiment[allSeriesIndex].data = sortedDates.map(date => ({
          x: this.formatDate(date),
          y: dateTotals[date] || 0
        }));
      } else {
        this.seriessentiment.unshift({
          name: "All",
          data: sortedDates.map(date => ({
            x: this.formatDate(date),
            y: dateTotals[date] || 0
          }))
        });
      }

      this.updateXAxisCategories(sortedDates);
    },

    processKeywordData(data, keyword) {
      const allDates = new Set();
      const platforms = [
        ...(data.date_mediaonline || []),
        ...(data.date_twitter || []),
        ...(data.date_tiktok || []),
        ...(data.date_youtube || [])
      ];

      const dateTotals = {};
      platforms.forEach(item => {
        const date = item.date;
        allDates.add(date);
        dateTotals[date] = (dateTotals[date] || 0) + item.Total;
      });

      const sortedDates = Array.from(allDates).sort();

      const seriesIndex = this.seriessentiment.findIndex(s => s.name == keyword);
      if (seriesIndex >= 0) {
        this.seriessentiment[seriesIndex].data = sortedDates.map(date => ({
          x: this.formatDate(date),
          y: dateTotals[date] || 0
        }));
      } else {
        this.seriessentiment.push({
          name: keyword,
          data: sortedDates.map(date => ({
            x: this.formatDate(date),
            y: dateTotals[date] || 0
          }))
        });
      }

      this.updateXAxisCategories(sortedDates);
    },

    updateXAxisCategories(newDates) {
      const currentCategories = this.sentimentanalysis.xaxis.categories || [];
      const newCategories = newDates.map(date => new Date(date).getTime());
      const mergedCategories = [...new Set([...currentCategories, ...newCategories])].sort();
      this.sentimentanalysis.xaxis.categories = mergedCategories;

      this.dialog = false;
    },

    formatDate(dateString) {
      if (!dateString) return '';

      const date = new Date(dateString);

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    },

    showPeriodeDate() {
      this.isShowDate = true;

      var date = new Date(this.dateStart);
      var day2 = (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) + "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) + "/" +
        date.getFullYear();

      const parts = day2.split("/");
      parts.unshift(parts.pop());
      parts[1] -= 1;
      var dateString = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts)).replace(/,/g, "");

      dateString = dateString.split(" ");
      this.showDateStart = dateString;

      var date3 = new Date(this.dateEnd);
      var day4 = (date3.getMonth() > 8 ? date3.getMonth() + 1 : "0" + (date3.getMonth() + 1)) + "/" +
        (date3.getDate() > 9 ? date3.getDate() : "0" + date3.getDate()) + "/" +
        date3.getFullYear();

      const parts2 = day4.split("/");
      parts2.unshift(parts2.pop());
      parts2[1] -= 1;
      var dateString2 = new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
      }).format(Date.UTC(...parts2)).replace(/,/g, "");

      dateString2 = dateString2.split(" ");
      this.showDateEnd = dateString2;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: this.selectedKeyword,
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: this.dateStart,
        date_end_glob: this.dateEnd,
        is_show_date_glob: this.isShowDate
      });
    },
  }
}
</script>

<style scoped>
.custom-date-picker ::v-deep .v-date-picker-table button {
  color: #000000 !important;
}
.custom-date-picker ::v-deep .v-date-picker-table button.v-btn--active {
  background-color: var(--color-theme) !important;
  color: #ffffff !important;
}
.confirm-reset {
  position: absolute; top: 10px; right: 10px;
}

.card-shadow {
  border-radius: 8px;
  color: #0471A5;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.apexcharts-toolbar {
  z-index: 0;
}
.row-pointer {
  cursor: grab;
}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  fill: #fff;
  font-weight: bold;
  font-size: 12px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.v-select.label {
  color: #fff;
}
.overflow-card {
  overflow-y: scroll;
  overflow-x: hidden;
}
.overflow-card-horizontal {
  overflow-x: scroll;
}
.v-avatar.color-avatarberitaonline {
  background-image:
  linear-gradient(to right top, #53d166, #5dd468, #65d769, #6eda6b, #76dd6d, #7ee06f, #86e271, #8de573, #96e876, #9fec79, #a8ef7c, #b1f27f);
}
.v-avatar.color-avatarXTikTok {
  background-image: linear-gradient(to right top, #000000, #000000) !important;
}
.v-avatar.color-avatarYtb {
  background-image:
  linear-gradient(to right top, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000, #FF0000) !important;
}
.v-avatar.color-avatarIG {
  background-image:
  linear-gradient(to right top, #f09433, #e6683c, #dc2743, #cc2366, #bc1888, #cb33b4, #d844ee, #ffdc80);
}
.highcharts-figure, .highcharts-data-table table {
  min-width: 320px;
  max-width: 800px;
  margin: 1em auto;
}
.highcharts-data-table table {
	font-family: Verdana, sans-serif;
	border-collapse: collapse;
	border: 1px solid #EBEBEB;
	margin: 10px auto;
	text-align: center;
	width: 100%;
	max-width: 500px;
}
.highcharts-data-table caption {
  padding: 1em 0;
  font-size: 1.2em;
  color: #555;
}
.highcharts-data-table th {
	font-weight: 600;
  padding: 0.5em;
}
.highcharts-data-table td, .highcharts-data-table th, .highcharts-data-table caption {
  padding: 0.5em;
}
.highcharts-data-table thead tr, .highcharts-data-table tr:nth-child(even) {
  background: #f8f8f8;
}
.highcharts-data-table tr:hover {
  background: #f1f7ff;
}
.rounded-lg {
  border-radius: 10px;
}
.btn-fix:hover::before { opacity: 0.08 !important; }
</style>